module.exports = __webpack_public_path__ + "img/Tendenz_steigend.2506a69f.svg";